<template>
    <div class="zplab-product">
        <img src="@/assets/images/zplab/actinum.jpg" alt="">
    </div>
</template>

<script>
export default {
    // mounted() {
    //     this.$emit("isShowBack", true)
    // },
}
</script>

<style lang="scss">
.zplab-product {
    padding: 10px;
    img {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
    }
}
</style>
